import styled from "styled-components";
import PropTypes from "prop-types";

const ConfigNavigation = styled.ul.attrs((props) => ({
  width: props.width || "180px",
}))`
  list-style: none;
  padding: 0;
  margin: 30px 0 0;

  width: ${({ width }) => width};
`;

ConfigNavigation.propTypes = {
  width: PropTypes.string,
};

ConfigNavigation.defaultProps = {
  width: "180px",
};

export default ConfigNavigation;
